module.exports = __webpack_public_path__ + "img/aboutUsHomeCart4.fd432821.png";